export default class CreateOrderDTO {
  constructor(currency, invoiceInformationId, orderItems) {
    this.currency = currency;
    this.invoiceInformationId = invoiceInformationId;
    this.orderItems = orderItems;
  }
}
